import React from "react"

export default function Footer() {
  return (
    <div className="footer">
      <span className="footer-item">
        <a target="blank" href="https://medium.com/@burubur">
          Medium
        </a>
      </span>
      <span className="footer-item">
        <a target="blank" href="https://twitter.com/burhanmubarok">
          Twitter
        </a>
      </span>
      <span className="footer-item">
        <a target="blank" href="https://github.com/burubur">
          Github
        </a>
      </span>
    </div>
  )
}
